<template>
  <figure class="thumbnail square rounded" :style="figureStyles">
    <img v-if="species.thumbnailUrl" :src="species.thumbnailUrl" :alt="altDescription" />
  </figure>
</template>

<script>
import Color from 'color'
import { thumbHashToDataURL } from 'thumbhash'

export default {
  props: {
    species: {
      type: Object,
      required: true
    }
  },

  computed: {
    altDescription () {
      return `Photo of ${this.species.commonName} (${this.species.scientificName})`
    },

    figureStyles () {
      return {
        borderColor: this.species.color,
        backgroundColor: Color(this.species.color).alpha(0.75),
        backgroundSize: '100% 100%',
        backgroundImage: this.thumbhashUrl
      }
    },

    thumbhashUrl () {
      if (this.species.thumbhash) {
        const bytes = atob(this.species.thumbhash).split('').map(x => x.charCodeAt(0))

        try {
          const dataUrl = thumbHashToDataURL(bytes)
          return `url(${dataUrl})`
        } catch {
          console.error('Invalid thumbhash:', this.hashValue)
        }
      }
    }
  }
}
</script>
